import { getAuth, onAuthStateChanged } from "@firebase/auth";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import AddHotel from "./components/AddHotel";
import CategoriesTableComponent from "./components/CategoriesTableComponent";
import Footer from "./components/common/Footer";
import Header from "./components/common/Header";
import DashboardHotelList from "./components/dashboardSupport/DashboardHotelList";
import HomePage from "./components/homePage/HomePage";
import AdminLayout from "./components/layouts/AdminLayout";
import Loading from "./components/Loader/Loading";
import ModalGlobal from "./components/ModalGlobal";
import CategoriesComponent from "./components/root/CategoriesComponent";
import ContractComponent from "./components/root/ContractComponent";
import HotelComponent from "./components/root/HotelComponent";
import OwnerComponent from "./components/root/OwnerComponent";
import Documents from "./components/root/registration/Documents";
import RegistrationLanding from "./components/root/registration/RegistrationLanding";
import {
  adminRoute,
  DashboardRoutes,
  merchantRoute,
  SummeryStatus,
  UserType
} from "./contants/Constants";
import AdminAddLocation from "./pages/admin/AdminAddLocation";
import AdminBookingAll from "./pages/admin/AdminBookingAll";
import AdminPriceCalc from "./pages/admin/AdminCalculator";
import AdminCancelledBookings from "./pages/admin/AdminCancelledBookings";
import AdminCategoryReview from "./pages/admin/AdminCategoryReview";
import AdminCheleKhelaSync from "./pages/admin/AdminCheleKhela";
import AdminCouponMange from "./pages/admin/AdminCouponManage";
import AdminCreateUser from "./pages/admin/AdminCreateUser";
import AdminDealsTool from "./pages/admin/AdminDealsTool";
import AdminFacilityManage from "./pages/admin/AdminFacilityManage";
import DispalayGroup from "./pages/admin/AdminFacilityToll/DisplayGroup";

import PropertyFacility from "./pages/admin/AdminFacilityToll/PropertyFacility";
import PropertyFacilityType from "./pages/admin/AdminFacilityToll/PropertyFacilityType";
import RoomCategoryFilter from "./pages/admin/AdminFacilityToll/RoomCategoryFilter";
import RoomCategoryType from "./pages/admin/AdminFacilityToll/RoomCategoryType";
import UiFilter from "./pages/admin/AdminFacilityToll/UiFilter";
import AdminFaq from "./pages/admin/AdminFaq";
import AdminHotelDetails from "./pages/admin/AdminHotelDetails";
import AdminHotelReview from "./pages/admin/AdminHotelReview";
import AdminHotelFacility from "./pages/admin/AdminHotelTool/AdminFacilitySetToll/AdminHotelFacility";
import AdminHotelSpecialityTool from "./pages/admin/AdminHotelTool/AdminHotelSpecialityTool/AdminHotelSpecialityTool";
import AdminAddThumbImage from "./pages/admin/AdminHotelTool/AdminThumbSetToll/AdminAddThumbImage";
import AdminInspiredLocations from "./pages/admin/AdminInspiredLocations";
import AdminInvoiceList from "./pages/admin/AdminInvoiceList";
import AdminInvoiceTool from "./pages/admin/AdminInvoiceTool";
import AdminCreateInvoice from "./pages/admin/adminInvoiceTools/AdminCreateInvoice";
import AdminCreatePaymentMethod from "./pages/admin/adminInvoiceTools/AdminCreatePaymentMethod";
import AdminCreatePaymentSlip from "./pages/admin/adminInvoiceTools/AdminCreatePaymentSlip";
import AdminInvoiceDetails from "./pages/admin/adminInvoiceTools/AdminInvoiceDetails";
import AdminInvoiceRecords from "./pages/admin/adminInvoiceTools/AdminInvoiceRecords";
import AdminVerifyPayment from "./pages/admin/adminInvoiceTools/AdminVerifyPayment";
import AdminLanding from "./pages/admin/AdminLanding";
import AdminNonExpressBookings from "./pages/admin/AdminNonExpressBokkings";
import AdminPayments from "./pages/admin/AdminPayments";
import AdminSetPrice from "./pages/admin/adminPriceTools/AdminSetPrice";
import AdminRejectedBookings from "./pages/admin/AdminRejectedBookings";
import AllContracts from "./pages/admin/AllContracts";
import AllDirectBookings from "./pages/admin/AllDirectBookings";
import CrewManagement from "./pages/admin/Dashboard/CrewManagement";
import MerchantDashboardCategories from "./pages/admin/Dashboard/MerchantDashboardCategories";
import AdminDashboard from "./pages/admin/Dashboard/MerchantDashboardMain";
import PolicyManagement from "./pages/admin/Dashboard/PolicyManagement";
import IconAndImages from "./pages/admin/IconAndImage";
import RolePermission from "./pages/admin/RolePermission";
import RolePermissionAssign from "./pages/admin/RolePermissionAssign";
import Roles from "./pages/admin/Roles";
import TermsAndCondtionsIndex from "./pages/admin/termsAndConditions";
import AdminTourAddCategory from "./pages/admin/Tour/AdminTourAddCat";
import AdminTourCreate from "./pages/admin/Tour/AdminTourCreate";
import AdminTourEdit from "./pages/admin/Tour/AdminTourEdit";
import AdminTourEditCategory from "./pages/admin/Tour/AdminTourEditCat";
import AdminTourList from "./pages/admin/Tour/AdminTourList";
import AdminTourManage from "./pages/admin/Tour/AdminTourManage";
import NewTourCreate from "./pages/admin/TourManagement/NewTourCreate";
import DashboardBooking from "./pages/DashboardBooking";
import LogIn from "./pages/LogIn";
import NotFound from "./pages/NotFound";
import Privacy from "./pages/privacy";
import SignIn from "./pages/SignIn";
import TaskManager from "./pages/TaskManager";
import Terms from "./pages/terms";
import "./selectscrollbar.css";
import { fetchSummeryGet } from "./store/registration/landingAccessFetchSummery/api/AccessFetchSummeryApi";
import { TestComponent } from "./test";
import PrivateRoute from "./utils/privateRoute";
import AdminCouponMangerNew from "./pages/admin/AdminCouponManagerNew";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  // let history = useHistory();
  const [userType, setUserType] = useState(process.env.REACT_APP_USER_TYPE);

  const fetchSummeryData = useSelector((state) => state.fetchSummeryReducer);
  // console.log(fetchSummeryData.data.contractId, "fetchSummeryData");

  localStorage.setItem(
    "contractId",
    fetchSummeryData.data ? fetchSummeryData.data.contractId : null
  );
  useEffect(() => {
    if (localStorage.getItem("contractId")) {
      dispatch(fetchSummeryGet(localStorage.getItem("id")));
    }
  }, []);

  // useEffect(() => {
  //   if(loggedIn){
  //     if(userType == UserType.ADMIN){
  //       console.log(userType == UserType.ADMIN, "ywfrhefuhreu")
  //       navigate(adminRoute.ADMIN_LANDING)
  //     }else{
  //       console.log(userType == UserType.ADMIN, "ywfrhefuhreu")
  //       navigate(merchantRoute.LANDING)
  //     }
  //   }else{
  //     console.log(userType == UserType.ADMIN, "ywfrhefuhreu")
  //     navigate(merchantRoute.SIGNIN)
  //   }
  // }, [loggedIn])

  useEffect(() => {
    if (
      fetchSummeryData.data.status === SummeryStatus.ACCEPTED &&
      userType === UserType.USER
    ) {
      // when registration accepted it will autometic move to dashboard
      // navigate(DashboardRoutes.DASHBOARD);
    }
    if (!fetchSummeryData.Loading) {
      setIsLoading(false);
    }
  }, [fetchSummeryData]);

  const auth = getAuth();
  onAuthStateChanged(auth, (user) => {
    if (user) {
      const uid = user.uid;
    } else {
      // navigate(merchantRoute.SIGNIN);
    }
  });

  if (isLoading) {
    return (
      <div className="w-full min-h-screen flex justify-center items-center">
        <Loading />
      </div>
    );
  }

  return (
    <div className="bg-bg-primary">
      <Header userType={userType} />
      <Routes>
        <Route path="/" element={<HomePage />} />
      </Routes>
      {userType === "ADMIN" ? (
        <div className="bg-bg-primary">
          <div className=" bg-bg-primary min-h-screen w-full border">
            <Routes>
              <Route
                path={adminRoute.ADMIN_LANDING}
                element={<AdminLayout Component={AdminLanding} />}
              />
              <Route
                path={adminRoute.ADMIN_ROLES}
                element={<AdminLayout Component={Roles} />}
              />
              <Route
                path={adminRoute.ADMIN_TERMS_CONDITIONS}
                element={<AdminLayout Component={TermsAndCondtionsIndex} />}
              />
              <Route
                path={adminRoute.ADMIN_SYNC_HOTEL}
                element={<AdminLayout Component={AdminCheleKhelaSync} />}
              />
              <Route
                path={adminRoute.ADMIN_TOURS}
                element={<AdminLayout Component={AdminTourList} />}
              />
              <Route
                path={adminRoute.ADMIN_TOUR_MANAGE}
                element={<AdminLayout Component={AdminTourManage} />}
              />
              <Route
                path={adminRoute.ADMIN_TOUR_CREATE}
                element={<AdminLayout Component={AdminTourCreate} />}
              />
              <Route
                path={adminRoute.ADMIN_TOUR_Details}
                element={<AdminLayout Component={AdminTourEdit} />}
              />
              <Route
                path={adminRoute.ADMIN_TOUR_ADD_CATEGORY}
                element={<AdminLayout Component={AdminTourAddCategory} />}
              />
              <Route
                path={adminRoute.ADMIN_TOUR_EDIT_CATEGORY}
                element={<AdminLayout Component={AdminTourEditCategory} />}
              />
              <Route
                path={adminRoute.ADMIN_PERMISSIONS}
                element={<AdminLayout Component={RolePermission} />}
              />
              <Route
                path={adminRoute.ADMIN_DEAL_TOOL}
                element={<AdminLayout Component={AdminDealsTool} />}
              />
              <Route
                path={adminRoute.ADMIN_ALL_INVOICE}
                element={<AdminLayout Component={AdminInvoiceList} />}
              />
              <Route
                path={adminRoute.ADMIN_INVOICE_TOOL}
                element={<AdminLayout Component={AdminInvoiceTool} />}
              />
              {/* ifcode */}
              <Route
                path={adminRoute.ADMIN_CREATE_INVOICE}
                element={<AdminLayout Component={AdminCreateInvoice} />}
              />
              <Route
                path={adminRoute.ADMIN_ALL_INVOICE_RECORDS}
                element={<AdminLayout Component={AdminInvoiceRecords} />}
              />
              <Route
                path={`${adminRoute.ADMIN_SINGLE_INVOICE_DETAILS}:id`}
                element={<AdminLayout Component={AdminInvoiceDetails} />}
              />
              <Route
                path={`${adminRoute.ADMIN_CREATE_PAYMENT_SLIP}:id`}
                element={<AdminLayout Component={AdminCreatePaymentSlip} />}
              />
              <Route
                path={adminRoute.ADMIN_CREATE_PAYMENT_METHOD}
                element={<AdminLayout Component={AdminCreatePaymentMethod} />}
              />
              <Route
                path={adminRoute.ADMIN_VERIFY_PAYMENTS}
                element={<AdminLayout Component={AdminVerifyPayment} />}
              />

              {/* <Route
                path={adminRoute.ADMIN_COUPON_MANAGE}
                element={<AdminLayout Component={AdminCouponMange} />}
              /> */}
              <Route
                path={adminRoute.ADMIN_COUPON_MANAGE}
                element={<AdminLayout Component={AdminCouponMangerNew} />}
              />
              <Route
                path={adminRoute.ADMIN_FACILITY_MANAGE}
                element={<AdminLayout Component={AdminFacilityManage} />}
              />
              <Route
                path={adminRoute.ADMIN_ICON_MANAGE}
                element={<AdminLayout Component={IconAndImages} />}
              />
              <Route
                path={adminRoute.ADMIN_CREATE_USER}
                element={<AdminLayout Component={AdminCreateUser} />}
              />
              <Route
                path={adminRoute.ADMIN_NON_EXPRESS_BOOKINGS}
                element={<AdminLayout Component={AdminNonExpressBookings} />}
              />
              <Route
                path={adminRoute.ADMIN_PERMISSIONS_ASSIGN}
                element={<AdminLayout Component={RolePermissionAssign} />}
              />
              <Route
                path={adminRoute.ADMIN_SUBMITTED_CONTRACTS}
                element={<AdminLayout Component={AllContracts} />}
              />
              <Route
                path={adminRoute.ADMIN_ALL_CONTRACTS}
                element={<AdminLayout Component={AllContracts} />}
              />
              <Route
                path={adminRoute.ADMIN_PAYMENTS}
                element={<AdminLayout Component={AdminPayments} />}
              />

              <Route
                path={adminRoute.ADMIN_SET_HOTEL_PRICE}
                element={<AdminLayout Component={AdminSetPrice} />}
              />

              <Route
                path={adminRoute.ADMIN_CALCULATOR}
                element={<AdminLayout Component={AdminPriceCalc} />}
              />
              <Route
                path={adminRoute.ADMIN_FAQ}
                element={<AdminLayout Component={AdminFaq} />}
              />
              <Route
                path={adminRoute.ADMIN_REVIEW_HOTEL}
                element={<AdminLayout Component={AdminHotelReview} />}
              />
              <Route
                path={adminRoute.ADMIN_HOTEL_DETAILS}
                element={<AdminLayout Component={AdminHotelDetails} />}
              />
              <Route
                path={adminRoute.ADMIN_REVIEW_CATEGORY}
                element={<AdminLayout Component={AdminCategoryReview} />}
              />
              <Route
                path={adminRoute.ADMIN_OWNER}
                element={<AdminLayout Component={OwnerComponent} />}
              />
              <Route
                path={adminRoute.ADMIN_CONTRACT}
                element={<AdminLayout Component={ContractComponent} />}
              />
              <Route
                path={adminRoute.ADMIN_BOOKINGS}
                element={<AdminLayout Component={AdminBookingAll} />}
              />
              <Route
                path={adminRoute.ADMIN_DIRECT_BOOKINGS}
                element={<AdminLayout Component={AllDirectBookings} />}
              />
              <Route
                path={adminRoute.ADMIN_REJECTIONS_BOOKINGS}
                element={<AdminLayout Component={AdminRejectedBookings} />}
              />
              <Route
                path={adminRoute.ADMIN_CANCELLATION_BOOKINGS}
                element={<AdminLayout Component={AdminCancelledBookings} />}
              />
              <Route
                path={adminRoute.ADMIN_INSPIRED_LOCATION}
                element={<AdminLayout Component={AdminInspiredLocations} />}
              />
              <Route
                path={adminRoute.ADMIN_ADD_LOCATION}
                element={<AdminLayout Component={AdminAddLocation} />}
              />
              <Route
                path={adminRoute.ADMIN_DOCUMENT}
                element={<AdminLayout Component={Documents} />}
              />
              <Route
                path={adminRoute.ADMIN_HOTELS}
                element={<AdminLayout Component={AddHotel} />}
              />
              <Route
                path={`${adminRoute.ADMIN_HOTEL}:id`}
                element={<AdminLayout Component={HotelComponent} />}
              />
              <Route
                path={adminRoute.ADMIN_CATEGORIES}
                element={<AdminLayout Component={CategoriesTableComponent} />}
              />
              <Route
                path={`${adminRoute.ADMIN_CATEGORY}:id`}
                element={<AdminLayout Component={CategoriesComponent} />}
              />

              {/* rasel */}

              <Route
                path={adminRoute.ADMIN_THUMB_IMAGE}
                element={<AdminLayout Component={AdminAddThumbImage} />}
              />
              <Route
                path={adminRoute.ADMIN_THUMB_IMAGE_DETAILS}
                element={<AdminLayout Component={AdminAddThumbImage} />}
              />
              <Route
                path={adminRoute.ADMIN_FETCH_ALL_HOTEL_FACILITY}
                element={<AdminLayout Component={AdminHotelFacility} />}
              />

              <Route
                path={adminRoute.ADMIN_FETCH_ALL_HOTEL_FACILITY_DETAILS}
                element={<AdminLayout Component={AdminHotelFacility} />}
              />

              <Route
                path={adminRoute.ADMIN_SET_HOTEL_SPECIALITY}
                element={<AdminLayout Component={AdminHotelSpecialityTool} />}
              />

              <Route
                path={adminRoute.ADMIN_SET_HOTEL_SPECIALITY_DETAILS}
                element={<AdminLayout Component={AdminHotelSpecialityTool} />}
              />

              <Route
                path={adminRoute.ADMIN_PROPERTY_FACILITY_TOOL}
                element={<AdminLayout Component={PropertyFacility} />}
              />

              <Route
                path={adminRoute.ADMIN_DISPLAY_GROUP_TOOL}
                element={<AdminLayout Component={DispalayGroup} />}
              />

              <Route
                path={adminRoute.ADMIN_FACILITY_TYPE}
                element={<AdminLayout Component={PropertyFacilityType} />}
              />
              <Route
                path={adminRoute.ADMIN_UI_FILTER}
                element={<AdminLayout Component={UiFilter} />}
              />
              <Route
                path={adminRoute.ADMIN_ROOM_CATEGORY_FILTER}
                element={<AdminLayout Component={RoomCategoryFilter} />}
              />
              <Route
                path={adminRoute.ADMIN_ROOM_CATEGORY_TYPE}
                element={<AdminLayout Component={RoomCategoryType} />}
              />

              {/* tour management */}

              <Route
                path={adminRoute.ADMIN_TOUR_CREATE_TOOL}
                element={<AdminLayout Component={NewTourCreate} />}
              />

              {/* <Route path="/admin" element={<AdminDashboard />} /> */}
              {/* <Route path="/form" element={<FormHandle />} /> */}
              {/* <Route path="/contract-status" element={<ContractStatus />} /> */}
              <Route
                path={merchantRoute.SIGNUP}
                element={<SignIn userType={UserType.ADMIN} />}
              />
              <Route
                path={merchantRoute.LOGIN}
                element={<LogIn userType={UserType.ADMIN} />}
              />
              {/* <Route path={adminRoute.ADMIN_THUMB_IMAGE} element={<AdminAddThumbImage/>} /> */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </div>
      ) : (
        <div className="bg-bg-primary">
          <div className=" bg-bg-primary min-h-screen">
            <Routes>
              <Route path="/test" element={<TestComponent />} />
              <Route
                path={merchantRoute.SIGNUP}
                element={<SignIn userType={UserType.USER} />}
              />
              <Route
                path={merchantRoute.LOGIN}
                element={<LogIn userType={UserType.USER} />}
              />
              <Route path="/bookingModal" element={<DashboardBooking />} />
              <Route path={merchantRoute.HOME} element={<HomePage />} />
              <Route
                path={DashboardRoutes.BOOKING}
                element={
                  <PrivateRoute
                    route={DashboardRoutes.BOOKING}
                    Component={TaskManager}
                  />
                }
              />
              <Route
                path={merchantRoute.LANDING}
                element={
                  <PrivateRoute
                    route={merchantRoute.LANDING}
                    Component={RegistrationLanding}
                  />
                }
              />
              <Route
                path={merchantRoute.OWNER}
                element={
                  <PrivateRoute
                    route={merchantRoute.OWNER}
                    Component={OwnerComponent}
                  />
                }
              />
              <Route
                path={merchantRoute.CONTRACT}
                element={
                  <PrivateRoute
                    route={merchantRoute.CONTRACT}
                    Component={ContractComponent}
                  />
                }
              />

              <Route
                path={merchantRoute.DOCUMENT}
                element={
                  <PrivateRoute
                    route={merchantRoute.DOCUMENT}
                    Component={Documents}
                  />
                }
              />

              <Route
                path={merchantRoute.HOTELS}
                element={
                  <PrivateRoute
                    route={merchantRoute.HOTELS}
                    Component={AddHotel}
                  />
                }
              />

              <Route
                path={`${merchantRoute.HOTEL}:id`}
                element={
                  <PrivateRoute
                    route={merchantRoute.HOTEL}
                    Component={HotelComponent}
                  />
                }
              />
              <Route
                path={merchantRoute.CATEGORIES}
                element={
                  <PrivateRoute
                    route={merchantRoute.CATEGORIES}
                    Component={CategoriesTableComponent}
                  />
                }
              />
              <Route
                path={`${merchantRoute.CATEGORY}:id`}
                element={
                  <PrivateRoute
                    route={merchantRoute.CATEGORY}
                    Component={CategoriesComponent}
                  />
                }
              />

              <Route
                path={DashboardRoutes.DASHBOARD}
                element={
                  <PrivateRoute
                    route={DashboardRoutes.DASHBOARD}
                    Component={AdminDashboard}
                  />
                }
              />
              <Route
                path={DashboardRoutes.POLICIES}
                element={
                  <PrivateRoute
                    route={DashboardRoutes.POLICIES}
                    Component={PolicyManagement}
                  />
                }
              />
              <Route
                path={DashboardRoutes.HOTELS}
                element={
                  <PrivateRoute
                    route={DashboardRoutes.HOTELS}
                    Component={DashboardHotelList}
                  />
                }
              />
              <Route
                path={DashboardRoutes.CREW}
                element={
                  <PrivateRoute
                    route={DashboardRoutes.CREW}
                    Component={CrewManagement}
                  />
                }
              />

              <Route
                path={DashboardRoutes.CATEGORIES}
                element={
                  <PrivateRoute
                    route={DashboardRoutes.CATEGORIES}
                    Component={MerchantDashboardCategories}
                  />
                }
              />

              <Route
                path={`${DashboardRoutes.HOTEL_DETAILS}:id`}
                element={
                  <PrivateRoute
                    route={`${DashboardRoutes.HOTEL_DETAILS}:id`}
                    Component={HotelComponent}
                  />
                }
              />

              <Route
                path={`${DashboardRoutes.CATEGORIES_DETAILS}:id`}
                element={
                  <PrivateRoute
                    route={`${DashboardRoutes.CATEGORIES_DETAILS}:id`}
                    Component={CategoriesComponent}
                  />
                }
              />
              <Route path="/ModalGlobal" element={<ModalGlobal />} />
              <Route path="/terms-and-conditions" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </div>
      )}

      {process.env.REACT_APP_USER_TYPE !== "ADMIN" && <Footer />}
    </div>
  );
}

export default App;
